import Common from '../Common';
import Calendar from './profile/Calendar';
import CallRouting from './profile/CallRouting';
import Cid from './profile/Cid';
import Queue from './profile/Queue';
import TriggerWord from './profile/TriggerWord';

interface Body {
	name: string
	priority: string
	profile_number?: string
	pbx_user_id?: string
	default_callerid_pbx_did_id?: string
	pbx_color_id?: number | string
	pbx_icon_id?: number | string
}

const Profile = class extends Common {
	queue: InstanceType<typeof Queue>;
	triggerWord: InstanceType<typeof TriggerWord>;
	cid: InstanceType<typeof Cid>;
	callRouting: InstanceType<typeof CallRouting>
	calendar: InstanceType<typeof Calendar>

	constructor(headers: ApiHeaders) {
		super(headers)

		this.queue = new Queue(headers);
		this.triggerWord = new TriggerWord(headers);
		this.cid = new Cid(headers)
		this.callRouting = new CallRouting(headers)
		this.calendar = new Calendar(headers)
	}

	read = (profileId: id) => this.get(`/profile/${profileId}`)
	create = (body: Body) => this.post(`/profile`, body)
	update = (profileId: id, body: Body) => this.patch(`/profile/${profileId}`, body)
	delete = (profileId: id) => this.doDelete(`/profile/${profileId}`)
	types = () => this.get("/profile/types")
}

export default Profile;
